import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Flex, Box } from "rebass";
import { AppBar } from "../components/AppBar";
import { Page } from "../components/Page";
import { LoginAuthenticationContainer } from "../containers/LoginAuthenticationContainer";

const AuthentcationView = ({ history }) => (
  <Flex flexDirection="column" width={1}>
    <Box flex="0 1 0">
      <Page title="VERIFY" />
      <AppBar>
        <AppBar.Button onClick={history.goBack}>
          <span aria-hidden="true">&lt; </span>BACK
        </AppBar.Button>
        <AppBar.Title>VERIFY</AppBar.Title>
      </AppBar>
    </Box>
    <Box flex="1 1 auto" width={1} p={20}>
      <LoginAuthenticationContainer />
    </Box>
  </Flex>
);

AuthentcationView.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(AuthentcationView);
